import { GET_INTERNAL_SOURCE_FACILITIES_SUCCESS } from "../actions/facilityAction"

export default (state = {}, { type, data = {} }) => {
  switch (type) {
    case GET_INTERNAL_SOURCE_FACILITIES_SUCCESS:
      return data
    default:
      return state
  }
}